var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overselection-warning"},[(_vm.showOverSelectionWarning)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    You may only select "+_vm._s(_vm.maxWinners)+" for this position.\n    Please de-select "+_vm._s(_vm.numOver)+" "+_vm._s(_vm.pluralized)+".\n")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }